//PRVX change here — ProveX (PRVX) ERC-20 for Buy flow balance reads
// UNSURE: no separate dev/test token address provided—confirm if local PulseChain needs a stub
export const ProveXContract = {
  abi: [
    {
      constant: true,
      inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
      name: 'balanceOf',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
  ],
  address: '0xF6f8Db0aBa00007681F8fAF16A0FDa1c9B030b11' as const,
}
